import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { LocalesContext } from '../../contexts/LocalesContext'
import { convertValue, getUnit } from '../../utils/unitsConverter'

export default function ConfResumeComponent(props) {
  const { t } = useContext(LocalesContext)
  const isImperial = props.unitsSystem === 'imperial'

  return (
    <div>
      {/* Work Mode Section */}
      <div className="c-content__title">{t('irriapp.titles.work_mode')}</div>
      <table className="c-table" style={{ marginBottom: '30px' }}>
        <tbody>
          <tr>
            <th>{t('irriapp.titles.work_mode')}</th>
            <td>{t(props.configuration.work_mod == 'm/h' ? 'irriapp.labels.speed' : 'irriapp.labels.height')}</td>
            <td className="mobile">
              <span><p>{t('irriapp.titles.work_mode')}</p><p>{t(props.configuration.work_mod == 'm/h' ? 'irriapp.labels.speed' : 'irriapp.labels.height')}</p></span>
            </td>
          </tr>
        </tbody>
      </table>

      {/* Sectors Section */}
      <div className="c-content__title">{t('irriapp.titles.sectors')}</div>
      <table className="c-table" style={{ marginBottom: '30px' }}>
        <thead>
          <tr>
            <th></th>
            <th>{t(props.configuration.work_mod == 'm/h' ? 'irriapp.labels.speed' : 'irriapp.labels.height')}</th>
            <th>{t('irriapp.labels.length')}</th>
          </tr>
        </thead>
        <tbody>
          {[1,2,3,4].map((number) => {
            const speed = props.configuration[`s${number}speed`]
            const height = props.configuration[`s${number}height`]
            const length = props.configuration[`s${number}length`]
            if (!speed || !length) return null

            return (
              <tr key={number}>
                <th>{t('irriapp.titles.sector')} {number}</th>
                <td>
                  {props.configuration.work_mod == 'm/h'
                    ? `${convertValue(speed, 'linear_speed', isImperial)} ${getUnit('linear_speed', isImperial)}`
                    : `${convertValue(height, 'height', isImperial)} ${getUnit('height', isImperial)}`
                  }
                </td>
                <td>{convertValue(length, 'distance', isImperial)} {getUnit('distance', isImperial)}</td>
                <td className="mobile">
                  <span><p>{t('irriapp.titles.sector')} {number}</p><p></p></span>
                  <span><p>{t(props.configuration.work_mod == 'm/h' ? 'irriapp.labels.speed' : 'irriapp.labels.height')}</p><p>{props.configuration.work_mod == 'm/h' 
                    ? `${convertValue(speed, 'linear_speed', isImperial)} ${getUnit('linear_speed', isImperial)}`
                    : `${convertValue(height, 'height', isImperial)} ${getUnit('height', isImperial)}`}</p></span>
                  <span><p>{t('irriapp.labels.length')}</p><p>{convertValue(length, 'distance', isImperial)} {getUnit('distance', isImperial)}</p></span>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>

      {/* Stops Section */}
      <div className="c-content__title">{t('irriapp.titles.stops')}</div>
      <table className="c-table" style={{ marginBottom: '30px' }}>
        <tbody>
          <tr>
            <th>{t('irriapp.labels.pause_start')}</th>
            <td>{props.configuration.pause_start} {t('application.units.minutes')}</td>
            <td className="mobile">
              <span><p>{t('irriapp.labels.pause_start')}</p><p>{props.configuration.pause_start} {t('application.units.minutes')}</p></span>
            </td>
          </tr>
          <tr>
            <th>{t('irriapp.labels.pause_end')}</th>
            <td>{props.configuration.pause_end} {t('application.units.minutes')}</td>
            <td className="mobile">
              <span><p>{t('irriapp.labels.pause_end')}</p><p>{props.configuration.pause_end} {t('application.units.minutes')}</p></span>
            </td>
          </tr>
        </tbody>
      </table>

      {/* Motormatic Section */}
      {!!props.configuration.motormaticc_active && (
        <>
          <div className="c-content__title">{t('irriapp.titles.motormatic')}</div>
          <table className="c-table">
            <tbody>
              <tr>
                <th>{t('irriapp.labels.pressure')}</th>
                <td>{convertValue(props.configuration.motormaticc_pressure, 'pressure', isImperial)} {getUnit('pressure', isImperial)}</td>
                <td className="mobile">
                  <span><p>{t('irriapp.labels.pressure')}</p><p>{convertValue(props.configuration.motormaticc_pressure, 'pressure', isImperial)} {getUnit('pressure', isImperial)}</p></span>
                </td>
              </tr>
            </tbody>
          </table>
        </>
      )}
    </div>
  )
}

ConfResumeComponent.propTypes = {
  configuration: PropTypes.object.isRequired,
  unitsSystem: PropTypes.string
}

ConfResumeComponent.defaultProps = {
  configuration: {},
  unitsSystem: 'metric'
}